import React from 'react'

const TeamAssignmentSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_984_19465)" />
    <path
      d="M22.3804 22.7136C25.6012 22.7136 28.1986 25.2591 28.1467 28.4279C28.1467 31.5448 25.4454 34.1941 22.3285 34.1941C19.2116 34.1941 16.5623 31.5448 16.5623 28.4279C16.5623 25.1552 19.1077 22.7136 22.3804 22.7136Z"
      fill="white"
    />
    <path
      d="M22.9 46.6097C23.4715 43.1292 24.978 40.0123 27.1078 37.5708C25.4974 36.7915 23.7312 36.376 21.8611 36.4799C16.8741 36.6357 12.6143 40.376 11.7312 45.311C11.4715 46.6617 11.991 47.285 13.3935 47.285C16.3546 47.285 19.3676 47.285 22.3286 47.285C22.4845 47.285 22.6403 47.285 22.7961 47.285C22.8481 47.0773 22.8481 46.8175 22.9 46.6097Z"
      fill="white"
    />
    <path
      d="M38.0171 19.4929C41.6535 19.4929 44.5626 22.3501 44.5626 25.9345C44.5626 29.415 41.4977 32.428 37.9652 32.428C34.4327 32.428 31.4717 29.415 31.4717 25.8825C31.4717 22.2981 34.3288 19.4929 38.0171 19.4929Z"
      fill="white"
    />
    <path
      d="M44.3026 41.8826C44.3026 40.3761 44.7701 38.9735 45.5493 37.7787C43.3155 36.0644 40.4584 35.0774 37.3935 35.1813C31.7831 35.441 26.9519 39.6488 25.9649 45.2073C25.7052 46.7657 26.2766 47.441 27.887 47.441C31.2636 47.441 34.5883 47.441 37.9649 47.441C40.9259 47.441 43.887 47.441 46.848 47.441C45.2896 46.1423 44.3026 44.1164 44.3026 41.8826Z"
      fill="white"
    />
    <path
      d="M52.043 36.324C55.1079 36.324 57.6014 38.8175 57.6014 41.8824C57.6014 44.9993 55.1079 47.4928 51.9911 47.4928C48.9261 47.4928 46.4326 44.9993 46.4326 41.9344C46.4326 38.8175 48.9261 36.324 52.043 36.324ZM51.2638 42.8694C51.1599 42.8175 51.1599 42.7655 51.1079 42.7655C50.6924 42.3499 50.3287 41.9863 49.9131 41.5707C49.7053 41.3629 49.4976 41.311 49.2898 41.4149C49.1859 41.4668 49.03 41.5707 48.9781 41.6746C48.7183 41.9344 48.7703 42.2461 48.9781 42.5058C49.6014 43.1292 50.2248 43.7525 50.8482 44.3759C51.1079 44.6357 51.4196 44.6357 51.6794 44.3759C52.8222 43.2331 53.9131 42.1422 55.056 40.9993C55.2118 40.8435 55.2638 40.6876 55.2118 40.4798C55.2118 40.324 55.1079 40.2201 55.004 40.1162C54.6404 39.7525 54.3807 39.7525 54.017 40.1162C53.1339 40.9993 52.2508 41.8824 51.2638 42.8694C51.3157 42.8175 51.3157 42.7655 51.2638 42.8694Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_984_19465"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07888D" />
        <stop offset="1" stopColor="#006064" />
      </linearGradient>
    </defs>
  </svg>
)

export default TeamAssignmentSubcategory
